export function openedSessionIdList (state) {
  return state?.openedSessionIdList ?? []
}

export function sessionList (state) {
  return state?.sessionList ?? []
}

export function openedSessionList (state, getters) {
  return getters.sessionList
    .filter(session => getters.openedSessionIdList.includes(session.id))
}

export function openableSessionList (state, getters) {
  return getters.sessionList
    .filter(session => !getters.openedSessionIdList.includes(session.id))
}

export function sessionLastRouteHistory (state) {
  return state.sessionLastRouteHistory
}
